export const ORG_ROLE_FIELD_NAME_EMAIL = 'Email';

const MemberAdministrationConstants = {
  ORG_ROLE_FIELD_NAME_EMAIL
};

export default MemberAdministrationConstants;